import { NlpModel, PromptStepSchema, QuestionStepSchema } from '@feedyou/schema'

import { FeedbotThunk } from '../../store/types'
import { runNlpModelsTest } from './utils/runNlpModelsTest'
import { replaceIntentIdsWithAnswers } from '../../components/nlp/intentLists/components/lists/StepNlpModelList/utils'
import { botFlowSelector } from '../../store/flow/selectors/botFlowSelector'
import { stepNlpModelSelector } from '../../store/botNlp/selectors'
import { alertInvalidTestModel } from './utils/toasting'

export const runNlpTestForStepThunk =
  (input: string, step: PromptStepSchema | QuestionStepSchema): FeedbotThunk<Promise<any>> =>
  async (dispatch, getState) => {
    const nlpModel = stepNlpModelSelector(step.id)(getState())

    if (!nlpModel) {
      alertInvalidTestModel(step.id)
      return
    }

    const model = replaceIntentIdsWithAnswers(nlpModel!, step)

    return dispatch(
      runNlpTestThunk({ input, models: [model], onlyQueryAgainstExpectedModel: false })
    )
  }

type RunNlpTestThunkParams = {
  input: string
  models: NlpModel[]
  onlyQueryAgainstExpectedModel: boolean
}

export const runNlpTestThunk =
  (params: RunNlpTestThunkParams): FeedbotThunk<Promise<any>> =>
  async (_, getState) => {
    const { input, onlyQueryAgainstExpectedModel, models } = params

    const bot = botFlowSelector(getState())

    return runNlpModelsTest({
      models,
      input,
      defaultLocale: bot?.defaultLocale,
      authenticationBotId: bot!.id,
      onlyQueryAgainstExpectedModel
    })
  }
